module.exports = __webpack_public_path__ + "static/media/sharding.b9667190.png";